import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import { RiCloseLine } from "@remixicon/react";
import { ShippingDialogProps } from "../../../types/Shipping";

interface BaseShippingDialogProps extends ShippingDialogProps {
  title: string;
  children: React.ReactNode;
  onSubmit?: () => void;
  submitDisabled?: boolean;
  submitText?: string;
}

const BaseShippingDialog: React.FC<BaseShippingDialogProps> = ({
  title,
  children,
  onClose,
  onSubmit,
  submitDisabled = false,
  submitText = "Submit",
}) => {
  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <RiCloseLine />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {onSubmit && (
          <Button
            onClick={onSubmit}
            variant="contained"
            color="primary"
            disabled={submitDisabled}
          >
            {submitText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default BaseShippingDialog;
